import { render, staticRenderFns } from "./RosettePopup.vue?vue&type=template&id=09a548cc&scoped=true&"
import script from "./RosettePopup.vue?vue&type=script&lang=js&"
export * from "./RosettePopup.vue?vue&type=script&lang=js&"
import style0 from "./RosettePopup.vue?vue&type=style&index=0&id=09a548cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a548cc",
  null
  
)

export default component.exports